import { useState } from "react";
import {
  IoCardOutline,
  IoMailOutline,
  IoEllipsisHorizontalOutline,
} from "react-icons/io5";
import { sendReceiptAsync } from "../../../../services/paymentService";
import TextboxSearch from "./../../../../components/common/TextboxSearch";
import PaymentsTable from "./components/PaymentsTable";
import Modal from "./../../../../components/common/Modal";
import Dropdown from "./../../../../components/common/Dropdown";
import Loader from "./../../../../components/common/Loader";
import Toaster from "./../../../../components/common/Toaster";
import PaymentForm from "./components/PaymentForm";

const Payments = ({ id }) => {
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sending, setSending] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    types: "",
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "created_on", order: "asc" },
  });

  const actions = (data) => {
    return [
      [
        {
          name: "Send Receipt via Email",
          icon: <IoMailOutline className="mr-3 text-blue-500" />,
          action: () => handleSendReceipt(data.id),
        },
      ],
    ];
  };

  const columns = [
    { path: "payment_number", label: "Payment No." },
    { path: "reference_number", label: "Reference No." },
    { path: "payment_type_name", label: "Payment Type" },
    { path: "amount", label: "Amount" },
    { path: "created_on", label: "Payment Date" },
    {
      key: "actions",
      content: (payment) => {
        return (
          <Dropdown
            items={actions(payment)}
            icon={<IoEllipsisHorizontalOutline />}
          />
        );
      },
    },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  const handleSendReceipt = async (id) => {
    try {
      setSending(true);

      await sendReceiptAsync(id);
      Toaster.Success("Receipt Sent Successfully");

      handleSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setSending(false);
    }
  };

  const handleSuccess = () => {
    const options = { ...tableOptions };
    setTableOptions(options);
    setShowForm(false);
  };

  return (
    <div className="card p-8">
      {sending && <Loader />}
      <div className="block sm:flex justify-between items-center">
        <div>
          <p className="text-gray-400 text-sm">Account Payments</p>
          <span className="text-gray-400 text-xs">
            List of Account Payments
          </span>
        </div>
        <div className="mt-5 sm:mt-0">
          <button
            className="button button-primary"
            onClick={() => setShowForm(true)}
          >
            <IoCardOutline className="mr-2" />
            Create Payment
          </button>
        </div>
      </div>
      <div className="block sm:justify-between items-center mt-8">
        <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
      </div>
      <div className="mt-8">
        <PaymentsTable
          id={id}
          columns={columns}
          tableOptions={tableOptions}
          onChange={handleOptionsChange}
        />
      </div>
      <Modal
        title="Create Payment"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <PaymentForm
          id={id}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default Payments;
